import LearnMoreButton from '../Components/LearnMoreButton'

function About() {
  return (
    <div>
      <h1>About Us</h1>
      <p>
        ShippersEdge is a provider of multi-carrier shipping software and TMS (Transportation Management Software).
        Other services include API &amp; EDI management and custom programming.
      </p>
      <p>
        Founded in 1998 as logistics technology consultants, we have been developing software since 2001.
        We have been recognized by Inbound Logistics as a Top 100 Logistics Technology provider every year since 2014.
      </p>
      <p>
        Our headquarters are located in the United States with clients based worldwide.
      </p>
      <div className="text-center"><LearnMoreButton /></div>
    </div>
  );
}

export default About
